import OatPrice from '../price'

export default class CartProduct {
  constructor({ id, name, price = null, promo = null, variant, vat = null}) {
    this.id = id;
    this.name = name;
    this.price = price !== null ? new OatPrice({ prices: [price] }) : null;
    this.promo = promo;
    this.variant = variant;
    this.vat = vat;
  }

  get total() {
    if(this.price === null) {
      return this.variant.price;
    } else {
      return this.price;
    }
  }

  static fromJSON(json) {
    const variant = {
      id: json.variant_id,
      name: json.variant_title_locale,
      sku: json.variant_sku,
      price: json.unit_price
    };

    return  { 
      id: json.product_id,
      name: json.product_title_locale,
      price: json.computed_unit_price,
      variant: variant,
      vat: json.computed_vat_price,
    };
  }
}